import { MoovStepCustomerParametersDTO } from "../DTO/moovStepCustomerParametersDTO";
import { BasicRequest } from "./basicRequest";

export class CreateMoovStepCustomerParametersRequest extends BasicRequest{
    
    public moovStepCustomerParameters!:MoovStepCustomerParametersDTO;

    constructor(){
        super();
    }
}